import type { TFunction } from 'i18next'

const CAMERA_ERROR_KEYS: Record<string, string> = {
	NotFoundError: 'qrScanner.cameraNotFound',
	OverconstrainedError: 'qrScanner.cameraNotFound',
	NotReadableError: 'qrScanner.cameraBusy',
	AbortError: 'qrScanner.cameraBusy',
}

const IOS_BROWSERS: [RegExp, string][] = [
	[/CriOS/, 'Chrome'],
	[/FxiOS/, 'Firefox'],
	[/EdgiOS/, 'Edge'],
]

// No iOS a permissão fica em lugares diferentes: o Safari tem Ajustes do Site, os outros navegadores dependem de Ajustes do iPhone
export function getBlockedMessage(t: TFunction): string {
	const ua = navigator.userAgent
	if (!/iPhone|iPad|iPod/.test(ua)) return t('qrScanner.cameraPermissionDenied')
	const other = IOS_BROWSERS.find(([pattern]) => pattern.test(ua))
	return other
		? t('qrScanner.cameraBlockedIosApp', { browser: other[1] })
		: t('qrScanner.cameraBlockedIosSafari')
}

// Inclui o nome do erro para facilitar o diagnóstico (ex.: no iOS)
export function getCameraErrorMessage(error: unknown, t: TFunction): string {
	const { name } = (error ?? {}) as { name?: string }
	const blocked = name === 'NotAllowedError' || name === 'PermissionDeniedError'
	const text = blocked
		? getBlockedMessage(t)
		: t((name && CAMERA_ERROR_KEYS[name]) || 'qrScanner.cameraUnknownError')
	return name ? `${text} [${name}]` : text
}
